class SpecialEditionVoyageData {
    constructor() {
      this.voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
      if (!this.voyageSelect) {
        // We'll try to create it later in the DOMContentLoaded event
        // For now, just get the form
        this.form = document.querySelector('form[action="/cart/add"]');
        
        if (!this.form) {
          return;
        }
        
        // Add form submit handler to verify all properties
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        
        // Add variant change handler
        document.addEventListener('variant:changed', this.handleVariantChange.bind(this));
        
        // We'll try to initialize the voyage select later

        return;
      }
      
      // Get the form
      const formId = this.voyageSelect.getAttribute('form');
      this.form = formId ? document.getElementById(formId) : document.querySelector('form[action="/cart/add"]');
      
      if (!this.form) {
        return;
      }
      
      // Add form submit handler to verify all properties
      this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
      
      // Load voyage data
      this.loadVoyageData();

      // Add variant change handler
      document.addEventListener('variant:changed', this.handleVariantChange.bind(this));
      
      // Check URL for satellite parameter on load
      setTimeout(() => {
        this.checkURLAndRestoreSelections();
      }, 500);

    }

    async loadVoyageData() {
      try {
        // Check if the voyage select exists
        if (!this.voyageSelect) {
          // Try to find the voyage select again
          this.voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
          
          // If still not found, we can't load voyage data
          if (!this.voyageSelect) {
            return Promise.resolve(null);
          }
        }
        
        const voyages = window.specialEdition.voyages;

        if (!voyages) {
          return Promise.resolve(null);
        }

        // Clear existing options except the first one
        while (this.voyageSelect.options.length > 1) {
          this.voyageSelect.remove(1);
        }

        // Add voyage options
        Object.entries(voyages).forEach(([voyageName, voyageData]) => {
          const formatDate = (dateStr) => {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return '';
            return date.toISOString().split('T')[0];
          };

          const option = document.createElement('option');
          option.value = voyageName;
          option.text = voyageName;
          option.dataset.shipName = voyageData.ship_name;
          option.dataset.startPort = voyageData.start_port;
          option.dataset.endPort = voyageData.end_port;
          option.dataset.startDate = formatDate(voyageData.start_date);
          option.dataset.endDate = formatDate(voyageData.end_date);
          this.voyageSelect.add(option);
        });

        // Initialize selectize if it's not already initialized
        if (window.jQuery && window.jQuery.fn.selectize && !this.voyageSelect.selectize) {
          try {
            const $select = window.jQuery(this.voyageSelect);
            if (!$select.data('selectize')) {
              $select.selectize({
                create: false,
                sortField: 'text',
                placeholder: 'Select a voyage...',
                allowEmptyOption: false
              });
            }
          } catch (error) {
            // Silently handle error
          }
        }

        // Rebuild selectize options if selectize is initialized
        if (this.voyageSelect.selectize) {
          this.voyageSelect.selectize.clear();
          this.voyageSelect.selectize.clearOptions();
          
          // Add options to selectize
          Object.entries(voyages).forEach(([voyageName, voyageData]) => {
            const formatDate = (dateStr) => {
              if (!dateStr) return '';
              const date = new Date(dateStr);
              if (isNaN(date.getTime())) return '';
              return date.toISOString().split('T')[0];
            };
            
            this.voyageSelect.selectize.addOption({
              value: voyageName,
              text: voyageName,
              shipName: voyageData.ship_name,
              startPort: voyageData.start_port,
              endPort: voyageData.end_port,
              startDate: formatDate(voyageData.start_date),
              endDate: formatDate(voyageData.end_date)
            });
          });
          
          // Refresh the selectize options
          this.voyageSelect.selectize.refreshOptions(false);
          
          // Add change handler
          this.voyageSelect.selectize.off('change'); // Remove any existing handlers
          this.voyageSelect.selectize.on('change', (value) => {
            try {
              if (!value) return;
              
              // Store selection in sessionStorage
              sessionStorage.setItem('selectedVoyage', value);
              // Also store in localStorage as a backup
              localStorage.setItem('lastSelectedVoyage', value);
              
              const option = this.voyageSelect.selectize.options[value];
              if (!option) {
                return;
              }
              
              const selectedData = {
                voyage: option.value,
                shipName: option.shipName,
                startPort: option.startPort,
                endPort: option.endPort,
                startDate: option.startDate,
                endDate: option.endDate
              };
              
              // Update other hidden inputs with the voyage data
              this.updateOrCreateHiddenInput('Ship Name', selectedData.shipName);
              this.updateOrCreateHiddenInput('Start Port', selectedData.startPort);
              this.updateOrCreateHiddenInput('End Port', selectedData.endPort);
              this.updateOrCreateHiddenInput('Start Date', selectedData.startDate);
              this.updateOrCreateHiddenInput('End Date', selectedData.endDate);
              
              // Remove any unnecessary properties
              this.removeHiddenInput('_futureDate');
              this.removeHiddenInput('_showLabels');
              this.removeHiddenInput('Title');
              this.removeHiddenInput('Voyage'); // This is already in the dropdown
              
              // Verify all inputs were created
              const requiredProperties = [
                'Ship Name',
                'Start Port',
                'End Port',
                'Start Date',
                'End Date'
              ];
              
              const missingProperties = requiredProperties.filter(prop => {
                const input = this.form.querySelector(`input[name="properties[${prop}]"]`);
                return !input || !input.value;
              });
            } catch (error) {
              // Silently handle error
            }
          });
        }

        return Promise.resolve(voyages);
      } catch (error) {
        return Promise.reject(error);
      }
    }

    handleVoyageSelection(event) {
      let selectedOption;
      let voyageData;
      
      // Handle both native select and selectize
      if (event.target.selectize) {
        const value = event.target.selectize.getValue();
        
        // Get the full option data from selectize
        const selectizeOption = event.target.selectize.options[value];
        
        // Find matching option in the original select
        selectedOption = Array.from(event.target.options).find(opt => opt.value === value);
      } else {
        selectedOption = event.target.options[event.target.selectedIndex];
      }
      
      if (!selectedOption) {
        return;
      }
      
      const selectedData = {
        voyage: selectedOption.value,
        shipName: selectedOption.dataset.shipName,
        startPort: selectedOption.dataset.startPort,
        endPort: selectedOption.dataset.endPort,
        startDate: selectedOption.dataset.startDate,
        endDate: selectedOption.dataset.endDate
      };
      
      // Only update if we have valid data
      if (selectedData.shipName) {
        // Update hidden inputs
        this.updateOrCreateHiddenInput('Ship Name', selectedData.shipName);
        this.updateOrCreateHiddenInput('Start Port', selectedData.startPort);
        this.updateOrCreateHiddenInput('End Port', selectedData.endPort);
        this.updateOrCreateHiddenInput('Start Date', selectedData.startDate);
        this.updateOrCreateHiddenInput('End Date', selectedData.endDate);
      }
    }

    updateOrCreateHiddenInput(propertyName, value) {

      try {
        const inputName = `properties[${propertyName}]`;
        let input = this.form.querySelector(`input[name="${inputName}"]`);
        
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = inputName;
          this.form.appendChild(input);
        }
        
        input.value = value || '';
        
        // Verify the input was actually added/updated
        const verifyInput = this.form.querySelector(`input[name="${inputName}"]`);
        if (verifyInput && verifyInput.value === value) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    }

    verifyLineItemProperties() {
      // First check if the voyage dropdown has a value selected
      const voyageSelect = this.voyageSelect;
      if (!voyageSelect || !voyageSelect.value) {
        return false;
      }
      
      // Get all properties
      const properties = Array.from(this.form.querySelectorAll('input[name^="properties["]'))
        .map(input => ({
          name: input.name,
          value: input.value
        }));
      
      // Verify all required properties are present
      const requiredProperties = [
        'Ship Name',
        'Start Port',
        'End Port',
        'Start Date',
        'End Date'
      ];
      
      const missingProperties = requiredProperties.filter(prop => 
        !properties.some(p => p.name === `properties[${prop}]` && p.value)
      );
      
      // If there are missing properties, try to update them automatically
      if (missingProperties.length > 0) {
        // Try to update the properties based on the current selection
        if (voyageSelect && voyageSelect.value) {
          this.updateVoyageProperties(voyageSelect.value);
          return true;
        }
        
        return false;
      }
      
      return true;
    }

    handleFormSubmit(event) {
      // Check if a voyage is selected
      if (!this.voyageSelect || !this.voyageSelect.value) {
        event.preventDefault();
        alert('Please select a voyage before adding to cart');
        return;
      }
      
      // Skip the verification of line item properties since they're hidden fields
      // that are automatically populated when a voyage is selected
      
      // Only check for visible, user-selectable fields
      const printSize = this.form.querySelector('select[name="properties[Print Size]"]:not([type="hidden"]), input[name="properties[Print Size]"]:not([type="hidden"])');
      const framing = this.form.querySelector('select[name="properties[Professional Hand-Framing Options]"]:not([type="hidden"]), input[name="properties[Professional Hand-Framing Options]"]:not([type="hidden"])');
      const layout = this.form.querySelector('select[name="properties[Layout]"]:not([type="hidden"]), input[name="properties[Layout]"]:not([type="hidden"])');

      const missingProperties = [];
      
      // Only check these fields if they are visible (not hidden)
      if (printSize && printSize.offsetParent !== null && !printSize.value) missingProperties.push('Print Size');
      if (framing && framing.offsetParent !== null && !framing.value) missingProperties.push('Professional Hand-Framing Options');
      if (layout && layout.offsetParent !== null && !layout.value) missingProperties.push('Layout');

      if (missingProperties.length > 0) {
        event.preventDefault();
        alert('Please select all required options: ' + missingProperties.join(', '));
        return;
      }
    }

    checkURLAndRestoreSelections() {
      try {
        // Check if the voyage select exists
        if (!this.voyageSelect) {
          // Try to find the voyage select again
          this.voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
          
          // If still not found, we can't restore selections
          if (!this.voyageSelect) {
            return;
          }
        }
        
        const params = new URLSearchParams(window.location.search);
        // Check for voyage parameter, shipname parameter, or stored voyage
        const voyage = params.get('voyage') || params.get('shipname');
        const storedVoyage = sessionStorage.getItem('selectedVoyage');
        const localStorageVoyage = localStorage.getItem('lastSelectedVoyage');
        const selectedVoyage = voyage || storedVoyage || localStorageVoyage;
        
        if (selectedVoyage) {
          // Make sure the option exists in the select before trying to set it
          const optionExists = Array.from(this.voyageSelect.options).some(opt => opt.value === selectedVoyage);
          
          if (!optionExists) {
            // If the option doesn't exist, we need to load the voyage data first
            this.loadVoyageData().then(() => {
              // Now try to set the value again
              if (this.voyageSelect.selectize) {
                this.voyageSelect.selectize.setValue(selectedVoyage, true);
                // Trigger voyage properties update
                this.updateVoyageProperties(selectedVoyage);
              } else {
                this.voyageSelect.value = selectedVoyage;
                this.voyageSelect.dispatchEvent(new Event('change'));
              }
            });
            
            return;
          }
          
          // Handle both native select and selectize
          if (this.voyageSelect.selectize) {
            this.voyageSelect.selectize.setValue(selectedVoyage, true);
            // Trigger voyage properties update
            this.updateVoyageProperties(selectedVoyage);
          } else {
            this.voyageSelect.value = selectedVoyage;
            this.voyageSelect.dispatchEvent(new Event('change'));
          }
          
          // Store the selection in both sessionStorage and localStorage for future use
          sessionStorage.setItem('selectedVoyage', selectedVoyage);
          localStorage.setItem('lastSelectedVoyage', selectedVoyage);
        } else {
          // No voyage selection to restore
          return;
        }
      } catch (error) {
        // Silently handle error
      }
    }

    generateVoyageLink() {
      try {
        const currentUrl = window.location.href;
        const baseUrl = currentUrl.split('?')[0];
        let newUrl;

        // Determine if we're switching to or from satellite
        if (baseUrl.includes('-satellite')) {
          newUrl = baseUrl.replace('-satellite', '');
        } else {
          newUrl = baseUrl + '-satellite';
        }

        // Get the current voyage selection from various sources
        const currentVoyage = this.voyageSelect?.value || 
                             sessionStorage.getItem('selectedVoyage') || 
                             localStorage.getItem('lastSelectedVoyage') || 
                             new URLSearchParams(window.location.search).get('voyage') || 
                             new URLSearchParams(window.location.search).get('shipname');
        
        // Add current selections to URL
        const params = new URLSearchParams();
        
        // Add voyage if available
        if (currentVoyage) {
          params.append('voyage', currentVoyage);
          
          // Store in both sessionStorage and localStorage for redundancy
          sessionStorage.setItem('selectedVoyage', currentVoyage);
          localStorage.setItem('lastSelectedVoyage', currentVoyage);
        }

        // Add other parameters if they exist
        const currentParams = new URLSearchParams(window.location.search);
        ['size', 'frame', 'orientation'].forEach(param => {
          const value = currentParams.get(param);
          if (value) params.append(param, value);
        });

        // Construct final URL
        if (params.toString()) {
          newUrl = `${newUrl}?${params.toString()}`;
        }
        
        window.location.href = newUrl;
      } catch (error) {
        // Silently handle error
      }
    }

    handleVariantChange(event) {
      // Check if the voyage select exists
      if (!this.voyageSelect) {
        // Try to find the voyage select again
        this.voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
      }
      
      // Store the current selection in sessionStorage before redirecting
      // This is critical for preserving the selection when switching variants
      const currentVoyage = this.voyageSelect?.value || 
                           sessionStorage.getItem('selectedVoyage') || 
                           new URLSearchParams(window.location.search).get('voyage') || 
                           new URLSearchParams(window.location.search).get('shipname');
      
      if (currentVoyage) {
        sessionStorage.setItem('selectedVoyage', currentVoyage);
        
        // Also store in localStorage as a backup (sessionStorage might be cleared)
        localStorage.setItem('lastSelectedVoyage', currentVoyage);
      }
      
      // If voyage select still not found, try to reload the page with the correct URL
      if (!this.voyageSelect) {
        const currentUrl = window.location.href;
        const baseUrl = currentUrl.split('?')[0];
        let newUrl;
        
        // Determine if we're switching to or from satellite
        if (baseUrl.includes('-satellite')) {
          newUrl = baseUrl.replace('-satellite', '');
        } else {
          newUrl = baseUrl + '-satellite';
        }
        
        // Add current voyage to URL if available
        const params = new URLSearchParams();
        if (currentVoyage) {
          params.append('voyage', currentVoyage);
        }
        
        // Add other parameters from current URL
        const currentParams = new URLSearchParams(window.location.search);
        ['size', 'frame', 'orientation'].forEach(param => {
          const value = currentParams.get(param);
          if (value) params.append(param, value);
        });
        
        // Construct final URL
        if (params.toString()) {
          newUrl = `${newUrl}?${params.toString()}`;
        }
        
        window.location.href = newUrl;
        return;
      }
      
      // Generate new URL with current selections
      this.generateVoyageLink();
    }

    async updateVoyageProperties(voyageValue) {
      try {
        // Check if the voyage select exists
        if (!this.voyageSelect) {
          // Try to find the voyage select again
          this.voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
          
          // If still not found, we can't update properties
          if (!this.voyageSelect) {
            return;
          }
        }
        
        // Get the voyage data from selectize options
        const select = document.querySelector('select[name="properties[Voyage]"]');
        
        // Check if selectize is initialized
        if (!select?.selectize) {
          // Try to initialize selectize
          if (window.jQuery && window.jQuery.fn.selectize) {
            try {
              const $select = window.jQuery(select);
              if (!$select.data('selectize')) {
                $select.selectize({
                  create: false,
                  sortField: 'text',
                  placeholder: 'Select a voyage...',
                  allowEmptyOption: false
                });
              }
            } catch (error) {
              return;
            }
          } else {
            return;
          }
        }
        
        // Check if options are available
        if (!select?.selectize?.options) {
          return;
        }

        // Find the option with the matching value
        const option = Object.values(select.selectize.options).find(opt => opt.value === voyageValue);
        if (!option) {
          return;
        }

        const selectedData = {
          voyage: option.value,
          shipName: option.shipName,
          startPort: option.startPort,
          endPort: option.endPort,
          startDate: option.startDate,
          endDate: option.endDate
        };
        
        // Update other hidden inputs with the voyage data
        this.updateOrCreateHiddenInput('Ship Name', selectedData.shipName);
        this.updateOrCreateHiddenInput('Start Port', selectedData.startPort);
        this.updateOrCreateHiddenInput('End Port', selectedData.endPort);
        this.updateOrCreateHiddenInput('Start Date', selectedData.startDate);
        this.updateOrCreateHiddenInput('End Date', selectedData.endDate);
        
        
        // Remove any unnecessary properties
        this.removeHiddenInput('_futureDate');
        this.removeHiddenInput('_showLabels');
        this.removeHiddenInput('Title');
        this.removeHiddenInput('Voyage'); // This is already in the dropdown

        return true;
      } catch (error) {
        return false;
      }
    }
    
    // Helper method to ensure a property exists with a default value
    ensurePropertyExists(propertyName, defaultValue) {
      const propertyInput = this.form.querySelector(`input[name="properties[${propertyName}]"], select[name="properties[${propertyName}]"]`);
      
      if (!propertyInput) {
        // Create a hidden input if it doesn't exist
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${propertyName}]`;
        input.value = defaultValue;
        this.form.appendChild(input);
      } else if (!propertyInput.value) {
        // Set the default value if the input exists but is empty
        propertyInput.value = defaultValue;
      }
    }
    
    // Helper method to remove a hidden input if it exists
    removeHiddenInput(propertyName) {
      try {
        const inputName = `properties[${propertyName}]`;
        const input = this.form.querySelector(`input[name="${inputName}"]`);
        if (input) {
          input.remove();
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    }

  }

  // Initialize after DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    // Check if the voyage select exists
    let voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
    
    // If the dropdown is missing, create it immediately
    if (!voyageSelect) {
      const productForm = document.querySelector('form[action="/cart/add"]');
      
      if (productForm) {
        // Find the appropriate place to insert the dropdown
        const insertPoint = productForm.querySelector('.product-form__input') || 
                           productForm.querySelector('.product__info-container');
        
        if (insertPoint) {
          // Create the voyage selector container
          const voyageSelector = document.createElement('div');
          voyageSelector.className = 'voyage-selector product-form__input';
          voyageSelector.innerHTML = `
            <label class="form__label" for="Voyage">Voyage</label>
            <div class="select">
              <select id="Voyage" name="properties[Voyage]" class="select__select" required>
                <option value="" disabled selected>Select a voyage...</option>
              </select>
              <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
              </svg>
            </div>
          `;
          
          // Insert before the first input or at the beginning of the container
          insertPoint.insertBefore(voyageSelector, insertPoint.firstChild);
          
          // Get the newly created select
          voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
        }
      }
    }
    
    // Initialize the voyage data handler
    window.voyageData = new SpecialEditionVoyageData();
    
    // If we have a voyage select, make sure it's properly initialized with selectize
    if (voyageSelect) {
      // Check if jQuery and Selectize are available
      if (window.jQuery && window.jQuery.fn.selectize) {
        // Initialize selectize on the voyage select
        try {
          const $select = window.jQuery(voyageSelect);
          if (!$select.data('selectize')) {
            $select.selectize({
              create: false,
              sortField: 'text',
              placeholder: 'Select a voyage...',
              allowEmptyOption: false
            });
          }
        } catch (error) {
          // Silently handle error
        }
      }
    }
    
    // Check for stored voyage selection
    const params = new URLSearchParams(window.location.search);
    const urlVoyage = params.get('voyage') || params.get('shipname');
    const storedVoyage = sessionStorage.getItem('selectedVoyage');
    const localStorageVoyage = localStorage.getItem('lastSelectedVoyage');
    const selectedVoyage = urlVoyage || storedVoyage || localStorageVoyage;
    
    // Add a small delay to ensure everything is initialized
    setTimeout(() => {
      // Refresh the voyage data
      if (window.voyageData && window.voyageData.voyageSelect) {
        window.voyageData.loadVoyageData().then(() => {
          // After loading the data, restore the selection
          window.voyageData.checkURLAndRestoreSelections();
          
          // If we have a selected voyage, make sure all properties are set
          if (selectedVoyage) {
            window.voyageData.updateVoyageProperties(selectedVoyage);
          }
        });
      } else if (window.voyageData) {
        // Try to find the voyage select again
        window.voyageData.voyageSelect = document.querySelector('select[name="properties[Voyage]"]');
        if (window.voyageData.voyageSelect) {
          window.voyageData.loadVoyageData().then(() => {
            // After loading the data, restore the selection
            window.voyageData.checkURLAndRestoreSelections();
            
            // If we have a selected voyage, make sure all properties are set
            if (selectedVoyage) {
              window.voyageData.updateVoyageProperties(selectedVoyage);
            }
          });
        }
      }
    }, 500);
  });